export default [
  {
    value: 'Pacific/Midway',
    label: '(GMT-11:00) American Samoa Standard Time - Midway',
  },
  { value: 'Pacific/Niue', label: '(GMT-11:00) Niue Time' },
  {
    value: 'Pacific/Pago_Pago',
    label: '(GMT-11:00) American Samoa Standard Time - Pago Pago',
  },
  { value: 'America/Adak', label: '(GMT-10:00) Hawaii-Aleutian Time - Adak' },
  {
    value: 'Pacific/Honolulu',
    label: '(GMT-10:00) Hawaii-Aleutian Standard Time - Honolulu',
  },
  {
    value: 'Pacific/Rarotonga',
    label: '(GMT-10:00) Cook Islands Standard Time - Rarotonga',
  },
  { value: 'Pacific/Tahiti', label: '(GMT-10:00) Tahiti Time' },
  { value: 'Pacific/Marquesas', label: '(GMT-09:30) Marquesas Time' },
  { value: 'America/Anchorage', label: '(GMT-09:00) Alaska Time - Anchorage' },
  { value: 'America/Juneau', label: '(GMT-09:00) Alaska Time - Juneau' },
  {
    value: 'America/Metlakatla',
    label: '(GMT-09:00) Alaska Time - Metlakatla',
  },
  { value: 'America/Nome', label: '(GMT-09:00) Alaska Time - Nome' },
  { value: 'America/Sitka', label: '(GMT-09:00) Alaska Time - Sitka' },
  { value: 'America/Yakutat', label: '(GMT-09:00) Alaska Time - Yakutat' },
  { value: 'Pacific/Gambier', label: '(GMT-09:00) Gambier Time' },
  {
    value: 'America/Los_Angeles',
    label: '(GMT-08:00) Pacific Time - Los Angeles',
  },
  { value: 'America/Tijuana', label: '(GMT-08:00) Pacific Time - Tijuana' },
  { value: 'America/Vancouver', label: '(GMT-08:00) Pacific Time - Vancouver' },
  { value: 'Pacific/Pitcairn', label: '(GMT-08:00) Pitcairn Time' },
  { value: 'America/Boise', label: '(GMT-07:00) Mountain Time - Boise' },
  {
    value: 'America/Cambridge_Bay',
    label: '(GMT-07:00) Mountain Time - Cambridge Bay',
  },
  {
    value: 'America/Ciudad_Juarez',
    label: '(GMT-07:00) Mountain Time - Ciudad Juarez',
  },
  {
    value: 'America/Creston',
    label: '(GMT-07:00) Mountain Standard Time - Creston',
  },
  { value: 'America/Dawson', label: '(GMT-07:00) Yukon Time - Dawson' },
  {
    value: 'America/Dawson_Creek',
    label: '(GMT-07:00) Mountain Standard Time - Dawson Creek',
  },
  { value: 'America/Denver', label: '(GMT-07:00) Mountain Time - Denver' },
  { value: 'America/Edmonton', label: '(GMT-07:00) Mountain Time - Edmonton' },
  {
    value: 'America/Fort_Nelson',
    label: '(GMT-07:00) Mountain Standard Time - Fort Nelson',
  },
  {
    value: 'America/Hermosillo',
    label: '(GMT-07:00) Mexican Pacific Standard Time - Hermosillo',
  },
  { value: 'America/Inuvik', label: '(GMT-07:00) Mountain Time - Inuvik' },
  {
    value: 'America/Mazatlan',
    label: '(GMT-07:00) Mexican Pacific Standard Time - Mazatlan',
  },
  {
    value: 'America/Phoenix',
    label: '(GMT-07:00) Mountain Standard Time - Phoenix',
  },
  { value: 'America/Whitehorse', label: '(GMT-07:00) Yukon Time - Whitehorse' },
  {
    value: 'America/Bahia_Banderas',
    label: '(GMT-06:00) Central Standard Time - Bahia Banderas',
  },
  {
    value: 'America/Belize',
    label: '(GMT-06:00) Central Standard Time - Belize',
  },
  { value: 'America/Chicago', label: '(GMT-06:00) Central Time - Chicago' },
  {
    value: 'America/Chihuahua',
    label: '(GMT-06:00) Central Standard Time - Chihuahua',
  },
  {
    value: 'America/Costa_Rica',
    label: '(GMT-06:00) Central Standard Time - Costa Rica',
  },
  {
    value: 'America/El_Salvador',
    label: '(GMT-06:00) Central Standard Time - El Salvador',
  },
  {
    value: 'America/Guatemala',
    label: '(GMT-06:00) Central Standard Time - Guatemala',
  },
  { value: 'America/Indiana/Knox', label: '(GMT-06:00) Central Time - Knox' },
  {
    value: 'America/Indiana/Tell_City',
    label: '(GMT-06:00) Central Time - Tell City',
  },
  {
    value: 'America/Managua',
    label: '(GMT-06:00) Central Standard Time - Managua',
  },
  { value: 'America/Matamoros', label: '(GMT-06:00) Central Time - Matamoros' },
  { value: 'America/Menominee', label: '(GMT-06:00) Central Time - Menominee' },
  {
    value: 'America/Merida',
    label: '(GMT-06:00) Central Standard Time - Merida',
  },
  {
    value: 'America/Mexico_City',
    label: '(GMT-06:00) Central Standard Time - Mexico City',
  },
  {
    value: 'America/Monterrey',
    label: '(GMT-06:00) Central Standard Time - Monterrey',
  },
  {
    value: 'America/North_Dakota/Beulah',
    label: '(GMT-06:00) Central Time - Beulah',
  },
  {
    value: 'America/North_Dakota/Center',
    label: '(GMT-06:00) Central Time - Center',
  },
  {
    value: 'America/North_Dakota/New_Salem',
    label: '(GMT-06:00) Central Time - New Salem',
  },
  { value: 'America/Ojinaga', label: '(GMT-06:00) Central Time - Ojinaga' },
  {
    value: 'America/Rankin_Inlet',
    label: '(GMT-06:00) Central Time - Rankin Inlet',
  },
  {
    value: 'America/Regina',
    label: '(GMT-06:00) Central Standard Time - Regina',
  },
  { value: 'America/Resolute', label: '(GMT-06:00) Central Time - Resolute' },
  {
    value: 'America/Swift_Current',
    label: '(GMT-06:00) Central Standard Time - Swift Current',
  },
  {
    value: 'America/Tegucigalpa',
    label: '(GMT-06:00) Central Standard Time - Tegucigalpa',
  },
  { value: 'America/Winnipeg', label: '(GMT-06:00) Central Time - Winnipeg' },
  { value: 'Pacific/Easter', label: '(GMT-06:00) Easter Island Time' },
  { value: 'Pacific/Galapagos', label: '(GMT-06:00) Galapagos Time' },
  {
    value: 'America/Atikokan',
    label: '(GMT-05:00) Eastern Standard Time - Atikokan',
  },
  {
    value: 'America/Bogota',
    label: '(GMT-05:00) Colombia Standard Time - Bogota',
  },
  {
    value: 'America/Cancun',
    label: '(GMT-05:00) Eastern Standard Time - Cancun',
  },
  {
    value: 'America/Cayman',
    label: '(GMT-05:00) Eastern Standard Time - Cayman',
  },
  { value: 'America/Detroit', label: '(GMT-05:00) Eastern Time - Detroit' },
  {
    value: 'America/Eirunepe',
    label: '(GMT-05:00) Acre Standard Time - Eirunepe',
  },
  {
    value: 'America/Grand_Turk',
    label: '(GMT-05:00) Eastern Time - Grand Turk',
  },
  { value: 'America/Guayaquil', label: '(GMT-05:00) Ecuador Time - Guayaquil' },
  { value: 'America/Havana', label: '(GMT-05:00) Cuba Time - Havana' },
  {
    value: 'America/Indiana/Indianapolis',
    label: '(GMT-05:00) Eastern Time - Indianapolis',
  },
  {
    value: 'America/Indiana/Marengo',
    label: '(GMT-05:00) Eastern Time - Marengo',
  },
  {
    value: 'America/Indiana/Petersburg',
    label: '(GMT-05:00) Eastern Time - Petersburg',
  },
  { value: 'America/Indiana/Vevay', label: '(GMT-05:00) Eastern Time - Vevay' },
  {
    value: 'America/Indiana/Vincennes',
    label: '(GMT-05:00) Eastern Time - Vincennes',
  },
  {
    value: 'America/Indiana/Winamac',
    label: '(GMT-05:00) Eastern Time - Winamac',
  },
  { value: 'America/Iqaluit', label: '(GMT-05:00) Eastern Time - Iqaluit' },
  {
    value: 'America/Jamaica',
    label: '(GMT-05:00) Eastern Standard Time - Jamaica',
  },
  {
    value: 'America/Kentucky/Louisville',
    label: '(GMT-05:00) Eastern Time - Louisville',
  },
  {
    value: 'America/Kentucky/Monticello',
    label: '(GMT-05:00) Eastern Time - Monticello',
  },
  { value: 'America/Lima', label: '(GMT-05:00) Peru Standard Time - Lima' },
  { value: 'America/Nassau', label: '(GMT-05:00) Eastern Time - Nassau' },
  { value: 'America/New_York', label: '(GMT-05:00) Eastern Time - New York' },
  {
    value: 'America/Panama',
    label: '(GMT-05:00) Eastern Standard Time - Panama',
  },
  {
    value: 'America/Port-au-Prince',
    label: '(GMT-05:00) Eastern Time - Port-au-Prince',
  },
  {
    value: 'America/Rio_Branco',
    label: '(GMT-05:00) Acre Standard Time - Rio Branco',
  },
  { value: 'America/Toronto', label: '(GMT-05:00) Eastern Time - Toronto' },
  {
    value: 'America/Anguilla',
    label: '(GMT-04:00) Atlantic Standard Time - Anguilla',
  },
  {
    value: 'America/Antigua',
    label: '(GMT-04:00) Atlantic Standard Time - Antigua',
  },
  {
    value: 'America/Aruba',
    label: '(GMT-04:00) Atlantic Standard Time - Aruba',
  },
  { value: 'America/Asuncion', label: '(GMT-04:00) Paraguay Time - Asuncion' },
  {
    value: 'America/Barbados',
    label: '(GMT-04:00) Atlantic Standard Time - Barbados',
  },
  {
    value: 'America/Blanc-Sablon',
    label: '(GMT-04:00) Atlantic Standard Time - Blanc-Sablon',
  },
  {
    value: 'America/Boa_Vista',
    label: '(GMT-04:00) Amazon Standard Time - Boa Vista',
  },
  {
    value: 'America/Campo_Grande',
    label: '(GMT-04:00) Amazon Standard Time - Campo Grande',
  },
  { value: 'America/Caracas', label: '(GMT-04:00) Venezuela Time - Caracas' },
  { value: 'America/Coyhaique', label: '(GMT-04:00) Chile Time - Coyhaique' },
  {
    value: 'America/Cuiaba',
    label: '(GMT-04:00) Amazon Standard Time - Cuiaba',
  },
  {
    value: 'America/Curacao',
    label: '(GMT-04:00) Atlantic Standard Time - Curacao',
  },
  {
    value: 'America/Dominica',
    label: '(GMT-04:00) Atlantic Standard Time - Dominica',
  },
  {
    value: 'America/Glace_Bay',
    label: '(GMT-04:00) Atlantic Time - Glace Bay',
  },
  {
    value: 'America/Goose_Bay',
    label: '(GMT-04:00) Atlantic Time - Goose Bay',
  },
  {
    value: 'America/Grenada',
    label: '(GMT-04:00) Atlantic Standard Time - Grenada',
  },
  {
    value: 'America/Guadeloupe',
    label: '(GMT-04:00) Atlantic Standard Time - Guadeloupe',
  },
  { value: 'America/Guyana', label: '(GMT-04:00) Guyana Time' },
  { value: 'America/Halifax', label: '(GMT-04:00) Atlantic Time - Halifax' },
  {
    value: 'America/Kralendijk',
    label: '(GMT-04:00) Atlantic Standard Time - Kralendijk',
  },
  { value: 'America/La_Paz', label: '(GMT-04:00) Bolivia Time - La Paz' },
  {
    value: 'America/Lower_Princes',
    label: '(GMT-04:00) Atlantic Standard Time - Lower Princes',
  },
  {
    value: 'America/Manaus',
    label: '(GMT-04:00) Amazon Standard Time - Manaus',
  },
  {
    value: 'America/Marigot',
    label: '(GMT-04:00) Atlantic Standard Time - Marigot',
  },
  {
    value: 'America/Martinique',
    label: '(GMT-04:00) Atlantic Standard Time - Martinique',
  },
  { value: 'America/Moncton', label: '(GMT-04:00) Atlantic Time - Moncton' },
  {
    value: 'America/Montserrat',
    label: '(GMT-04:00) Atlantic Standard Time - Montserrat',
  },
  {
    value: 'America/Port_of_Spain',
    label: '(GMT-04:00) Atlantic Standard Time - Port of Spain',
  },
  {
    value: 'America/Porto_Velho',
    label: '(GMT-04:00) Amazon Standard Time - Porto Velho',
  },
  {
    value: 'America/Puerto_Rico',
    label: '(GMT-04:00) Atlantic Standard Time - Puerto Rico',
  },
  { value: 'America/Santiago', label: '(GMT-04:00) Chile Time - Santiago' },
  {
    value: 'America/Santo_Domingo',
    label: '(GMT-04:00) Atlantic Standard Time - Santo Domingo',
  },
  {
    value: 'America/St_Barthelemy',
    label: '(GMT-04:00) Atlantic Standard Time - St Barthelemy',
  },
  {
    value: 'America/St_Kitts',
    label: '(GMT-04:00) Atlantic Standard Time - St Kitts',
  },
  {
    value: 'America/St_Lucia',
    label: '(GMT-04:00) Atlantic Standard Time - St Lucia',
  },
  {
    value: 'America/St_Thomas',
    label: '(GMT-04:00) Atlantic Standard Time - St Thomas',
  },
  {
    value: 'America/St_Vincent',
    label: '(GMT-04:00) Atlantic Standard Time - St Vincent',
  },
  { value: 'America/Thule', label: '(GMT-04:00) Atlantic Time - Thule' },
  {
    value: 'America/Tortola',
    label: '(GMT-04:00) Atlantic Standard Time - Tortola',
  },
  { value: 'Atlantic/Bermuda', label: '(GMT-04:00) Atlantic Time - Bermuda' },
  {
    value: 'America/St_Johns',
    label: '(GMT-03:30) Newfoundland Time - St Johns',
  },
  {
    value: 'America/Araguaina',
    label: '(GMT-03:00) Brasilia Standard Time - Araguaina',
  },
  {
    value: 'America/Argentina/Buenos_Aires',
    label: '(GMT-03:00) Argentina Standard Time - Buenos Aires',
  },
  {
    value: 'America/Argentina/Catamarca',
    label: '(GMT-03:00) Argentina Standard Time - Catamarca',
  },
  {
    value: 'America/Argentina/Cordoba',
    label: '(GMT-03:00) Argentina Standard Time - Cordoba',
  },
  {
    value: 'America/Argentina/Jujuy',
    label: '(GMT-03:00) Argentina Standard Time - Jujuy',
  },
  {
    value: 'America/Argentina/La_Rioja',
    label: '(GMT-03:00) Argentina Standard Time - La Rioja',
  },
  {
    value: 'America/Argentina/Mendoza',
    label: '(GMT-03:00) Argentina Standard Time - Mendoza',
  },
  {
    value: 'America/Argentina/Rio_Gallegos',
    label: '(GMT-03:00) Argentina Standard Time - Rio Gallegos',
  },
  {
    value: 'America/Argentina/Salta',
    label: '(GMT-03:00) Argentina Standard Time - Salta',
  },
  {
    value: 'America/Argentina/San_Juan',
    label: '(GMT-03:00) Argentina Standard Time - San Juan',
  },
  {
    value: 'America/Argentina/San_Luis',
    label: '(GMT-03:00) Argentina Standard Time - San Luis',
  },
  {
    value: 'America/Argentina/Tucuman',
    label: '(GMT-03:00) Argentina Standard Time - Tucuman',
  },
  {
    value: 'America/Argentina/Ushuaia',
    label: '(GMT-03:00) Argentina Standard Time - Ushuaia',
  },
  {
    value: 'America/Bahia',
    label: '(GMT-03:00) Brasilia Standard Time - Bahia',
  },
  {
    value: 'America/Belem',
    label: '(GMT-03:00) Brasilia Standard Time - Belem',
  },
  {
    value: 'America/Cayenne',
    label: '(GMT-03:00) French Guiana Time - Cayenne',
  },
  {
    value: 'America/Fortaleza',
    label: '(GMT-03:00) Brasilia Standard Time - Fortaleza',
  },
  {
    value: 'America/Maceio',
    label: '(GMT-03:00) Brasilia Standard Time - Maceio',
  },
  {
    value: 'America/Miquelon',
    label: '(GMT-03:00) St. Pierre & Miquelon Time',
  },
  {
    value: 'America/Montevideo',
    label: '(GMT-03:00) Uruguay Standard Time - Montevideo',
  },
  {
    value: 'America/Paramaribo',
    label: '(GMT-03:00) Suriname Time - Paramaribo',
  },
  { value: 'America/Punta_Arenas', label: '(GMT-03:00) Punta Arenas Time' },
  {
    value: 'America/Recife',
    label: '(GMT-03:00) Brasilia Standard Time - Recife',
  },
  {
    value: 'America/Santarem',
    label: '(GMT-03:00) Brasilia Standard Time - Santarem',
  },
  {
    value: 'America/Sao_Paulo',
    label: '(GMT-03:00) Brasilia Standard Time - Sao Paulo',
  },
  { value: 'Antarctica/Palmer', label: '(GMT-03:00) Palmer Land Time' },
  { value: 'Antarctica/Rothera', label: '(GMT-03:00) Rothera Time' },
  {
    value: 'Atlantic/Stanley',
    label: '(GMT-03:00) Falkland Islands Standard Time - Stanley',
  },
  {
    value: 'America/Noronha',
    label: '(GMT-02:00) Fernando de Noronha Standard Time',
  },
  { value: 'America/Nuuk', label: '(GMT-02:00) West Greenland Time - Nuuk' },
  { value: 'Atlantic/South_Georgia', label: '(GMT-02:00) South Georgia Time' },
  {
    value: 'America/Scoresbysund',
    label: '(GMT-01:00) East Greenland Time - Scoresbysund',
  },
  { value: 'Atlantic/Azores', label: '(GMT-01:00) Azores Time' },
  {
    value: 'Atlantic/Cape_Verde',
    label: '(GMT-01:00) Cape Verde Standard Time',
  },
  {
    value: 'Africa/Abidjan',
    label: '(GMT+00:00) Greenwich Mean Time - Abidjan',
  },
  { value: 'Africa/Accra', label: '(GMT+00:00) Greenwich Mean Time - Accra' },
  { value: 'Africa/Bamako', label: '(GMT+00:00) Greenwich Mean Time - Bamako' },
  { value: 'Africa/Banjul', label: '(GMT+00:00) Greenwich Mean Time - Banjul' },
  { value: 'Africa/Bissau', label: '(GMT+00:00) Greenwich Mean Time - Bissau' },
  {
    value: 'Africa/Conakry',
    label: '(GMT+00:00) Greenwich Mean Time - Conakry',
  },
  { value: 'Africa/Dakar', label: '(GMT+00:00) Greenwich Mean Time - Dakar' },
  {
    value: 'Africa/Freetown',
    label: '(GMT+00:00) Greenwich Mean Time - Freetown',
  },
  { value: 'Africa/Lome', label: '(GMT+00:00) Greenwich Mean Time - Lome' },
  {
    value: 'Africa/Monrovia',
    label: '(GMT+00:00) Greenwich Mean Time - Monrovia',
  },
  {
    value: 'Africa/Nouakchott',
    label: '(GMT+00:00) Greenwich Mean Time - Nouakchott',
  },
  {
    value: 'Africa/Ouagadougou',
    label: '(GMT+00:00) Greenwich Mean Time - Ouagadougou',
  },
  {
    value: 'Africa/Sao_Tome',
    label: '(GMT+00:00) Greenwich Mean Time - Sao Tome',
  },
  {
    value: 'America/Danmarkshavn',
    label: '(GMT+00:00) Greenwich Mean Time - Danmarkshavn',
  },
  { value: 'Antarctica/Troll', label: '(GMT+00:00) Troll Station Time' },
  {
    value: 'Atlantic/Canary',
    label: '(GMT+00:00) Western European Time - Canary',
  },
  {
    value: 'Atlantic/Faroe',
    label: '(GMT+00:00) Western European Time - Faroe',
  },
  {
    value: 'Atlantic/Madeira',
    label: '(GMT+00:00) Western European Time - Madeira',
  },
  {
    value: 'Atlantic/Reykjavik',
    label: '(GMT+00:00) Greenwich Mean Time - Reykjavik',
  },
  {
    value: 'Atlantic/St_Helena',
    label: '(GMT+00:00) Greenwich Mean Time - St Helena',
  },
  { value: 'Europe/Dublin', label: '(GMT+00:00) Ireland Time - Dublin' },
  { value: 'Europe/Guernsey', label: '(GMT+00:00) Guernsey Time' },
  { value: 'Europe/Isle_of_Man', label: '(GMT+00:00) Isle of Man Time' },
  { value: 'Europe/Jersey', label: '(GMT+00:00) Jersey Time' },
  {
    value: 'Europe/Lisbon',
    label: '(GMT+00:00) Western European Time - Lisbon',
  },
  { value: 'Europe/London', label: '(GMT+00:00) United Kingdom Time - London' },
  { value: 'UTC', label: '(GMT+00:00) Coordinated Universal Time' },
  {
    value: 'Africa/Algiers',
    label: '(GMT+01:00) Central European Standard Time - Algiers',
  },
  { value: 'Africa/Bangui', label: '(GMT+01:00) West Africa Time - Bangui' },
  {
    value: 'Africa/Brazzaville',
    label: '(GMT+01:00) West Africa Time - Brazzaville',
  },
  {
    value: 'Africa/Casablanca',
    label: '(GMT+01:00) Morocco Time - Casablanca',
  },
  { value: 'Africa/Ceuta', label: '(GMT+01:00) Central European Time - Ceuta' },
  { value: 'Africa/Douala', label: '(GMT+01:00) West Africa Time - Douala' },
  {
    value: 'Africa/El_Aaiun',
    label: '(GMT+01:00) Western Sahara Time - El Aaiun',
  },
  {
    value: 'Africa/Kinshasa',
    label: '(GMT+01:00) West Africa Time - Kinshasa',
  },
  { value: 'Africa/Lagos', label: '(GMT+01:00) West Africa Time - Lagos' },
  {
    value: 'Africa/Libreville',
    label: '(GMT+01:00) West Africa Time - Libreville',
  },
  { value: 'Africa/Luanda', label: '(GMT+01:00) West Africa Time - Luanda' },
  { value: 'Africa/Malabo', label: '(GMT+01:00) West Africa Time - Malabo' },
  {
    value: 'Africa/Ndjamena',
    label: '(GMT+01:00) West Africa Time - Ndjamena',
  },
  { value: 'Africa/Niamey', label: '(GMT+01:00) West Africa Time - Niamey' },
  {
    value: 'Africa/Porto-Novo',
    label: '(GMT+01:00) West Africa Time - Porto-Novo',
  },
  {
    value: 'Africa/Tunis',
    label: '(GMT+01:00) Central European Standard Time - Tunis',
  },
  {
    value: 'Arctic/Longyearbyen',
    label: '(GMT+01:00) Central European Time - Longyearbyen',
  },
  {
    value: 'Europe/Amsterdam',
    label: '(GMT+01:00) Central European Time - Amsterdam',
  },
  {
    value: 'Europe/Andorra',
    label: '(GMT+01:00) Central European Time - Andorra',
  },
  {
    value: 'Europe/Belgrade',
    label: '(GMT+01:00) Central European Time - Belgrade',
  },
  {
    value: 'Europe/Berlin',
    label: '(GMT+01:00) Central European Time - Berlin',
  },
  {
    value: 'Europe/Bratislava',
    label: '(GMT+01:00) Central European Time - Bratislava',
  },
  {
    value: 'Europe/Brussels',
    label: '(GMT+01:00) Central European Time - Brussels',
  },
  {
    value: 'Europe/Budapest',
    label: '(GMT+01:00) Central European Time - Budapest',
  },
  {
    value: 'Europe/Busingen',
    label: '(GMT+01:00) Central European Time - Busingen',
  },
  {
    value: 'Europe/Copenhagen',
    label: '(GMT+01:00) Central European Time - Copenhagen',
  },
  {
    value: 'Europe/Gibraltar',
    label: '(GMT+01:00) Central European Time - Gibraltar',
  },
  {
    value: 'Europe/Ljubljana',
    label: '(GMT+01:00) Central European Time - Ljubljana',
  },
  {
    value: 'Europe/Luxembourg',
    label: '(GMT+01:00) Central European Time - Luxembourg',
  },
  {
    value: 'Europe/Madrid',
    label: '(GMT+01:00) Central European Time - Madrid',
  },
  { value: 'Europe/Malta', label: '(GMT+01:00) Central European Time - Malta' },
  {
    value: 'Europe/Monaco',
    label: '(GMT+01:00) Central European Time - Monaco',
  },
  { value: 'Europe/Oslo', label: '(GMT+01:00) Central European Time - Oslo' },
  { value: 'Europe/Paris', label: '(GMT+01:00) Central European Time - Paris' },
  {
    value: 'Europe/Podgorica',
    label: '(GMT+01:00) Central European Time - Podgorica',
  },
  {
    value: 'Europe/Prague',
    label: '(GMT+01:00) Central European Time - Prague',
  },
  { value: 'Europe/Rome', label: '(GMT+01:00) Central European Time - Rome' },
  {
    value: 'Europe/San_Marino',
    label: '(GMT+01:00) Central European Time - San Marino',
  },
  {
    value: 'Europe/Sarajevo',
    label: '(GMT+01:00) Central European Time - Sarajevo',
  },
  {
    value: 'Europe/Skopje',
    label: '(GMT+01:00) Central European Time - Skopje',
  },
  {
    value: 'Europe/Stockholm',
    label: '(GMT+01:00) Central European Time - Stockholm',
  },
  {
    value: 'Europe/Tirane',
    label: '(GMT+01:00) Central European Time - Tirane',
  },
  { value: 'Europe/Vaduz', label: '(GMT+01:00) Central European Time - Vaduz' },
  {
    value: 'Europe/Vatican',
    label: '(GMT+01:00) Central European Time - Vatican',
  },
  {
    value: 'Europe/Vienna',
    label: '(GMT+01:00) Central European Time - Vienna',
  },
  {
    value: 'Europe/Warsaw',
    label: '(GMT+01:00) Central European Time - Warsaw',
  },
  {
    value: 'Europe/Zagreb',
    label: '(GMT+01:00) Central European Time - Zagreb',
  },
  {
    value: 'Europe/Zurich',
    label: '(GMT+01:00) Central European Time - Zurich',
  },
  {
    value: 'Africa/Blantyre',
    label: '(GMT+02:00) Central Africa Time - Blantyre',
  },
  {
    value: 'Africa/Bujumbura',
    label: '(GMT+02:00) Central Africa Time - Bujumbura',
  },
  { value: 'Africa/Cairo', label: '(GMT+02:00) Eastern European Time - Cairo' },
  {
    value: 'Africa/Gaborone',
    label: '(GMT+02:00) Central Africa Time - Gaborone',
  },
  { value: 'Africa/Harare', label: '(GMT+02:00) Central Africa Time - Harare' },
  {
    value: 'Africa/Johannesburg',
    label: '(GMT+02:00) South Africa Standard Time - Johannesburg',
  },
  { value: 'Africa/Juba', label: '(GMT+02:00) Central Africa Time - Juba' },
  {
    value: 'Africa/Khartoum',
    label: '(GMT+02:00) Central Africa Time - Khartoum',
  },
  { value: 'Africa/Kigali', label: '(GMT+02:00) Central Africa Time - Kigali' },
  {
    value: 'Africa/Lubumbashi',
    label: '(GMT+02:00) Central Africa Time - Lubumbashi',
  },
  { value: 'Africa/Lusaka', label: '(GMT+02:00) Central Africa Time - Lusaka' },
  { value: 'Africa/Maputo', label: '(GMT+02:00) Central Africa Time - Maputo' },
  {
    value: 'Africa/Maseru',
    label: '(GMT+02:00) South Africa Standard Time - Maseru',
  },
  {
    value: 'Africa/Mbabane',
    label: '(GMT+02:00) South Africa Standard Time - Mbabane',
  },
  {
    value: 'Africa/Tripoli',
    label: '(GMT+02:00) Eastern European Standard Time - Tripoli',
  },
  {
    value: 'Africa/Windhoek',
    label: '(GMT+02:00) Central Africa Time - Windhoek',
  },
  { value: 'Asia/Beirut', label: '(GMT+02:00) Eastern European Time - Beirut' },
  {
    value: 'Asia/Famagusta',
    label: '(GMT+02:00) Eastern European Time - Famagusta',
  },
  { value: 'Asia/Gaza', label: '(GMT+02:00) Eastern European Time - Gaza' },
  { value: 'Asia/Hebron', label: '(GMT+02:00) Eastern European Time - Hebron' },
  { value: 'Asia/Jerusalem', label: '(GMT+02:00) Israel Time - Jerusalem' },
  {
    value: 'Asia/Nicosia',
    label: '(GMT+02:00) Eastern European Time - Nicosia',
  },
  {
    value: 'Europe/Athens',
    label: '(GMT+02:00) Eastern European Time - Athens',
  },
  {
    value: 'Europe/Bucharest',
    label: '(GMT+02:00) Eastern European Time - Bucharest',
  },
  {
    value: 'Europe/Chisinau',
    label: '(GMT+02:00) Eastern European Time - Chisinau',
  },
  {
    value: 'Europe/Helsinki',
    label: '(GMT+02:00) Eastern European Time - Helsinki',
  },
  {
    value: 'Europe/Kaliningrad',
    label: '(GMT+02:00) Eastern European Standard Time - Kaliningrad',
  },
  { value: 'Europe/Kyiv', label: '(GMT+02:00) Eastern European Time - Kyiv' },
  {
    value: 'Europe/Mariehamn',
    label: '(GMT+02:00) Eastern European Time - Mariehamn',
  },
  { value: 'Europe/Riga', label: '(GMT+02:00) Eastern European Time - Riga' },
  { value: 'Europe/Sofia', label: '(GMT+02:00) Eastern European Time - Sofia' },
  {
    value: 'Europe/Tallinn',
    label: '(GMT+02:00) Eastern European Time - Tallinn',
  },
  {
    value: 'Europe/Vilnius',
    label: '(GMT+02:00) Eastern European Time - Vilnius',
  },
  {
    value: 'Africa/Addis_Ababa',
    label: '(GMT+03:00) East Africa Time - Addis Ababa',
  },
  { value: 'Africa/Asmara', label: '(GMT+03:00) East Africa Time - Asmara' },
  {
    value: 'Africa/Dar_es_Salaam',
    label: '(GMT+03:00) East Africa Time - Dar es Salaam',
  },
  {
    value: 'Africa/Djibouti',
    label: '(GMT+03:00) East Africa Time - Djibouti',
  },
  { value: 'Africa/Kampala', label: '(GMT+03:00) East Africa Time - Kampala' },
  {
    value: 'Africa/Mogadishu',
    label: '(GMT+03:00) East Africa Time - Mogadishu',
  },
  { value: 'Africa/Nairobi', label: '(GMT+03:00) East Africa Time - Nairobi' },
  { value: 'Antarctica/Syowa', label: '(GMT+03:00) Syowa Time' },
  { value: 'Asia/Aden', label: '(GMT+03:00) Arabian Standard Time - Aden' },
  { value: 'Asia/Amman', label: '(GMT+03:00) Jordan Time - Amman' },
  {
    value: 'Asia/Baghdad',
    label: '(GMT+03:00) Arabian Standard Time - Baghdad',
  },
  {
    value: 'Asia/Bahrain',
    label: '(GMT+03:00) Arabian Standard Time - Bahrain',
  },
  { value: 'Asia/Damascus', label: '(GMT+03:00) Syria Time - Damascus' },
  { value: 'Asia/Kuwait', label: '(GMT+03:00) Arabian Standard Time - Kuwait' },
  { value: 'Asia/Qatar', label: '(GMT+03:00) Arabian Standard Time - Qatar' },
  { value: 'Asia/Riyadh', label: '(GMT+03:00) Arabian Standard Time - Riyadh' },
  {
    value: 'Europe/Istanbul',
    label: '(GMT+03:00) Türkiye Standard Time - Istanbul',
  },
  { value: 'Europe/Kirov', label: '(GMT+03:00) Moscow Standard Time - Kirov' },
  { value: 'Europe/Minsk', label: '(GMT+03:00) Moscow Standard Time - Minsk' },
  { value: 'Europe/Moscow', label: '(GMT+03:00) Moscow Standard Time' },
  {
    value: 'Europe/Simferopol',
    label: '(GMT+03:00) Moscow Standard Time - Simferopol',
  },
  {
    value: 'Europe/Volgograd',
    label: '(GMT+03:00) Moscow Standard Time - Volgograd',
  },
  {
    value: 'Indian/Antananarivo',
    label: '(GMT+03:00) East Africa Time - Antananarivo',
  },
  { value: 'Indian/Comoro', label: '(GMT+03:00) East Africa Time - Comoro' },
  { value: 'Indian/Mayotte', label: '(GMT+03:00) East Africa Time - Mayotte' },
  { value: 'Asia/Tehran', label: '(GMT+03:30) Iran Standard Time - Tehran' },
  { value: 'Asia/Baku', label: '(GMT+04:00) Azerbaijan Standard Time - Baku' },
  { value: 'Asia/Dubai', label: '(GMT+04:00) Gulf Standard Time - Dubai' },
  { value: 'Asia/Muscat', label: '(GMT+04:00) Gulf Standard Time - Muscat' },
  {
    value: 'Asia/Tbilisi',
    label: '(GMT+04:00) Georgia Standard Time - Tbilisi',
  },
  {
    value: 'Asia/Yerevan',
    label: '(GMT+04:00) Armenia Standard Time - Yerevan',
  },
  {
    value: 'Europe/Astrakhan',
    label: '(GMT+04:00) Samara Standard Time - Astrakhan',
  },
  { value: 'Europe/Samara', label: '(GMT+04:00) Samara Standard Time' },
  {
    value: 'Europe/Saratov',
    label: '(GMT+04:00) Samara Standard Time - Saratov',
  },
  {
    value: 'Europe/Ulyanovsk',
    label: '(GMT+04:00) Samara Standard Time - Ulyanovsk',
  },
  { value: 'Indian/Mahe', label: '(GMT+04:00) Seychelles Time - Mahe' },
  { value: 'Indian/Mauritius', label: '(GMT+04:00) Mauritius Standard Time' },
  { value: 'Indian/Reunion', label: '(GMT+04:00) Réunion Time' },
  { value: 'Asia/Kabul', label: '(GMT+04:30) Afghanistan Time - Kabul' },
  { value: 'Antarctica/Mawson', label: '(GMT+05:00) Mawson Time' },
  { value: 'Antarctica/Vostok', label: '(GMT+05:00) Vostok Time' },
  { value: 'Asia/Almaty', label: '(GMT+05:00) East Kazakhstan Time - Almaty' },
  { value: 'Asia/Aqtau', label: '(GMT+05:00) West Kazakhstan Time - Aqtau' },
  { value: 'Asia/Aqtobe', label: '(GMT+05:00) West Kazakhstan Time - Aqtobe' },
  {
    value: 'Asia/Ashgabat',
    label: '(GMT+05:00) Turkmenistan Standard Time - Ashgabat',
  },
  { value: 'Asia/Atyrau', label: '(GMT+05:00) West Kazakhstan Time - Atyrau' },
  { value: 'Asia/Dushanbe', label: '(GMT+05:00) Tajikistan Time - Dushanbe' },
  {
    value: 'Asia/Karachi',
    label: '(GMT+05:00) Pakistan Standard Time - Karachi',
  },
  { value: 'Asia/Oral', label: '(GMT+05:00) West Kazakhstan Time - Oral' },
  {
    value: 'Asia/Qostanay',
    label: '(GMT+05:00) East Kazakhstan Time - Qostanay',
  },
  {
    value: 'Asia/Qyzylorda',
    label: '(GMT+05:00) West Kazakhstan Time - Qyzylorda',
  },
  {
    value: 'Asia/Samarkand',
    label: '(GMT+05:00) Uzbekistan Standard Time - Samarkand',
  },
  {
    value: 'Asia/Tashkent',
    label: '(GMT+05:00) Uzbekistan Standard Time - Tashkent',
  },
  {
    value: 'Asia/Yekaterinburg',
    label: '(GMT+05:00) Yekaterinburg Standard Time',
  },
  {
    value: 'Indian/Kerguelen',
    label: '(GMT+05:00) French Southern & Antarctic Time - Kerguelen',
  },
  { value: 'Indian/Maldives', label: '(GMT+05:00) Maldives Time' },
  { value: 'Asia/Colombo', label: '(GMT+05:30) India Standard Time - Colombo' },
  { value: 'Asia/Kolkata', label: '(GMT+05:30) India Standard Time - Kolkata' },
  { value: 'Asia/Kathmandu', label: '(GMT+05:45) Nepal Time - Kathmandu' },
  { value: 'Asia/Bishkek', label: '(GMT+06:00) Kyrgyzstan Time - Bishkek' },
  {
    value: 'Asia/Dhaka',
    label: '(GMT+06:00) Bangladesh Standard Time - Dhaka',
  },
  { value: 'Asia/Omsk', label: '(GMT+06:00) Omsk Standard Time' },
  { value: 'Asia/Thimphu', label: '(GMT+06:00) Bhutan Time - Thimphu' },
  { value: 'Asia/Urumqi', label: '(GMT+06:00) Ürümqi Time' },
  { value: 'Indian/Chagos', label: '(GMT+06:00) Indian Ocean Time - Chagos' },
  { value: 'Asia/Yangon', label: '(GMT+06:30) Myanmar Time - Yangon' },
  { value: 'Indian/Cocos', label: '(GMT+06:30) Cocos Islands Time' },
  { value: 'Antarctica/Davis', label: '(GMT+07:00) Davis Time' },
  { value: 'Asia/Bangkok', label: '(GMT+07:00) Indochina Time - Bangkok' },
  {
    value: 'Asia/Barnaul',
    label: '(GMT+07:00) Krasnoyarsk Standard Time - Barnaul',
  },
  {
    value: 'Asia/Ho_Chi_Minh',
    label: '(GMT+07:00) Indochina Time - Ho Chi Minh',
  },
  { value: 'Asia/Hovd', label: '(GMT+07:00) Khovd Standard Time' },
  {
    value: 'Asia/Jakarta',
    label: '(GMT+07:00) Western Indonesia Time - Jakarta',
  },
  { value: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk Standard Time' },
  {
    value: 'Asia/Novokuznetsk',
    label: '(GMT+07:00) Krasnoyarsk Standard Time - Novokuznetsk',
  },
  {
    value: 'Asia/Novosibirsk',
    label: '(GMT+07:00) Krasnoyarsk Standard Time - Novosibirsk',
  },
  {
    value: 'Asia/Phnom_Penh',
    label: '(GMT+07:00) Indochina Time - Phnom Penh',
  },
  {
    value: 'Asia/Pontianak',
    label: '(GMT+07:00) Western Indonesia Time - Pontianak',
  },
  {
    value: 'Asia/Tomsk',
    label: '(GMT+07:00) Krasnoyarsk Standard Time - Tomsk',
  },
  { value: 'Asia/Vientiane', label: '(GMT+07:00) Indochina Time - Vientiane' },
  { value: 'Indian/Christmas', label: '(GMT+07:00) Christmas Island Time' },
  {
    value: 'Antarctica/Casey',
    label: '(GMT+08:00) Australian Western Standard Time - Casey',
  },
  { value: 'Asia/Brunei', label: '(GMT+08:00) Brunei Time' },
  { value: 'Asia/Hong_Kong', label: '(GMT+08:00) Hong Kong Standard Time' },
  { value: 'Asia/Irkutsk', label: '(GMT+08:00) Irkutsk Standard Time' },
  {
    value: 'Asia/Kuala_Lumpur',
    label: '(GMT+08:00) Malaysia Time - Kuala Lumpur',
  },
  { value: 'Asia/Kuching', label: '(GMT+08:00) Malaysia Time - Kuching' },
  { value: 'Asia/Macau', label: '(GMT+08:00) China Standard Time - Macau' },
  {
    value: 'Asia/Makassar',
    label: '(GMT+08:00) Central Indonesia Time - Makassar',
  },
  {
    value: 'Asia/Manila',
    label: '(GMT+08:00) Philippine Standard Time - Manila',
  },
  {
    value: 'Asia/Shanghai',
    label: '(GMT+08:00) China Standard Time - Shanghai',
  },
  { value: 'Asia/Singapore', label: '(GMT+08:00) Singapore Standard Time' },
  { value: 'Asia/Taipei', label: '(GMT+08:00) Taiwan Standard Time - Taipei' },
  { value: 'Asia/Ulaanbaatar', label: '(GMT+08:00) Ulaanbaatar Standard Time' },
  {
    value: 'Australia/Perth',
    label: '(GMT+08:00) Australian Western Standard Time - Perth',
  },
  {
    value: 'Australia/Eucla',
    label: '(GMT+08:45) Australian Central Western Standard Time - Eucla',
  },
  { value: 'Asia/Chita', label: '(GMT+09:00) Yakutsk Standard Time - Chita' },
  { value: 'Asia/Dili', label: '(GMT+09:00) Timor-Leste Time - Dili' },
  {
    value: 'Asia/Jayapura',
    label: '(GMT+09:00) Eastern Indonesia Time - Jayapura',
  },
  {
    value: 'Asia/Khandyga',
    label: '(GMT+09:00) Yakutsk Standard Time - Khandyga',
  },
  {
    value: 'Asia/Pyongyang',
    label: '(GMT+09:00) Korean Standard Time - Pyongyang',
  },
  { value: 'Asia/Seoul', label: '(GMT+09:00) Korean Standard Time - Seoul' },
  { value: 'Asia/Tokyo', label: '(GMT+09:00) Japan Standard Time - Tokyo' },
  { value: 'Asia/Yakutsk', label: '(GMT+09:00) Yakutsk Standard Time' },
  { value: 'Pacific/Palau', label: '(GMT+09:00) Palau Time' },
  {
    value: 'Australia/Adelaide',
    label: '(GMT+09:30) Australian Central Time - Adelaide',
  },
  {
    value: 'Australia/Broken_Hill',
    label: '(GMT+09:30) Australian Central Time - Broken Hill',
  },
  {
    value: 'Australia/Darwin',
    label: '(GMT+09:30) Australian Central Standard Time - Darwin',
  },
  {
    value: 'Antarctica/DumontDUrville',
    label: '(GMT+10:00) Dumont d’Urville Time',
  },
  {
    value: 'Antarctica/Macquarie',
    label: '(GMT+10:00) Australian Eastern Time - Macquarie',
  },
  {
    value: 'Asia/Ust-Nera',
    label: '(GMT+10:00) Vladivostok Standard Time - Ust-Nera',
  },
  { value: 'Asia/Vladivostok', label: '(GMT+10:00) Vladivostok Standard Time' },
  {
    value: 'Australia/Brisbane',
    label: '(GMT+10:00) Australian Eastern Standard Time - Brisbane',
  },
  {
    value: 'Australia/Hobart',
    label: '(GMT+10:00) Australian Eastern Time - Hobart',
  },
  {
    value: 'Australia/Lindeman',
    label: '(GMT+10:00) Australian Eastern Standard Time - Lindeman',
  },
  {
    value: 'Australia/Melbourne',
    label: '(GMT+10:00) Australian Eastern Time - Melbourne',
  },
  {
    value: 'Australia/Sydney',
    label: '(GMT+10:00) Australian Eastern Time - Sydney',
  },
  { value: 'Pacific/Chuuk', label: '(GMT+10:00) Chuuk Time' },
  { value: 'Pacific/Guam', label: '(GMT+10:00) Chamorro Standard Time - Guam' },
  {
    value: 'Pacific/Port_Moresby',
    label: '(GMT+10:00) Papua New Guinea Time - Port Moresby',
  },
  {
    value: 'Pacific/Saipan',
    label: '(GMT+10:00) Chamorro Standard Time - Saipan',
  },
  { value: 'Australia/Lord_Howe', label: '(GMT+10:30) Lord Howe Time' },
  { value: 'Asia/Magadan', label: '(GMT+11:00) Magadan Standard Time' },
  {
    value: 'Asia/Sakhalin',
    label: '(GMT+11:00) Magadan Standard Time - Sakhalin',
  },
  {
    value: 'Asia/Srednekolymsk',
    label: '(GMT+11:00) Magadan Standard Time - Srednekolymsk',
  },
  { value: 'Pacific/Bougainville', label: '(GMT+11:00) Bougainville Time' },
  {
    value: 'Pacific/Efate',
    label: '(GMT+11:00) Vanuatu Standard Time - Efate',
  },
  {
    value: 'Pacific/Guadalcanal',
    label: '(GMT+11:00) Solomon Islands Time - Guadalcanal',
  },
  { value: 'Pacific/Kosrae', label: '(GMT+11:00) Kosrae Time' },
  { value: 'Pacific/Norfolk', label: '(GMT+11:00) Norfolk Island Time' },
  {
    value: 'Pacific/Noumea',
    label: '(GMT+11:00) New Caledonia Standard Time - Noumea',
  },
  { value: 'Pacific/Pohnpei', label: '(GMT+11:00) Pohnpei Time' },
  {
    value: 'Antarctica/McMurdo',
    label: '(GMT+12:00) New Zealand Time - McMurdo',
  },
  {
    value: 'Asia/Anadyr',
    label: '(GMT+12:00) Kamchatka Standard Time - Anadyr',
  },
  { value: 'Asia/Kamchatka', label: '(GMT+12:00) Kamchatka Standard Time' },
  {
    value: 'Pacific/Auckland',
    label: '(GMT+12:00) New Zealand Time - Auckland',
  },
  { value: 'Pacific/Fiji', label: '(GMT+12:00) Fiji Standard Time' },
  { value: 'Pacific/Funafuti', label: '(GMT+12:00) Tuvalu Time - Funafuti' },
  {
    value: 'Pacific/Kwajalein',
    label: '(GMT+12:00) Marshall Islands Time - Kwajalein',
  },
  {
    value: 'Pacific/Majuro',
    label: '(GMT+12:00) Marshall Islands Time - Majuro',
  },
  { value: 'Pacific/Nauru', label: '(GMT+12:00) Nauru Time' },
  {
    value: 'Pacific/Tarawa',
    label: '(GMT+12:00) Gilbert Islands Time - Tarawa',
  },
  { value: 'Pacific/Wake', label: '(GMT+12:00) Wake Island Time' },
  { value: 'Pacific/Wallis', label: '(GMT+12:00) Wallis & Futuna Time' },
  { value: 'Pacific/Chatham', label: '(GMT+12:45) Chatham Time' },
  { value: 'Pacific/Apia', label: '(GMT+13:00) Samoa Standard Time - Apia' },
  { value: 'Pacific/Fakaofo', label: '(GMT+13:00) Tokelau Time - Fakaofo' },
  {
    value: 'Pacific/Kanton',
    label: '(GMT+13:00) Phoenix Islands Time - Kanton',
  },
  {
    value: 'Pacific/Tongatapu',
    label: '(GMT+13:00) Tonga Standard Time - Tongatapu',
  },
  {
    value: 'Pacific/Kiritimati',
    label: '(GMT+14:00) Line Islands Time - Kiritimati',
  },
];
